import React, { Component } from "react";
import { Box, Button, Text } from "@chakra-ui/react";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error("Error caught by ErrorBoundary:", error, errorInfo);
    }

    handleReset = () => {
        this.setState({ hasError: false });
    };

    render() {
        if (this.state.hasError) {
            return (
                <Box p="20px" textAlign="center" bg="red.900" color="white">
                    <Text fontSize="lg">Something went wrong.</Text>
                    <Button mt="10px" onClick={this.handleReset}>Try Again</Button>
                </Box>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
